
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CatalogExternalViewType, CatalogViewDto, SocialMediaType, TrackMailDto, TrackSocialMediaDto } from '@commonInterfaces/CatalogInfoModel';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
	selector: 'lib-catalog-contact',
	templateUrl: './catalog-contact.component.html',
	styleUrls: ['./catalog-contact.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ButtonComponent, TranslatePipe]
})
export class CatalogContactComponent implements OnInit {

	@Input() catalogInfo?: CatalogViewDto;

	public catalogExternalViewType = CatalogExternalViewType;
	public socialMediaType = SocialMediaType;


	@Output() contactFormOpen = new EventEmitter<any>();
	@Output() trackMail = new EventEmitter<TrackMailDto>();
	@Output() trackSocialMedia = new EventEmitter<TrackSocialMediaDto>();

	constructor() { }

	ngOnInit(): void { }

	public trackWebEmailEvent(type: CatalogExternalViewType, targetUrl: string) {
		this.trackMail.emit({
			link: targetUrl,
			viewType: type
		});
	}

	public trackSocialMediaEvent(type: SocialMediaType, targetUrl: string) {
		this.trackSocialMedia.emit({
			link: targetUrl,
			socialMediaType: type
		});
	}


	public getSocialMediaLogo(type: SocialMediaType): string {
		const prefix = 'assets\\orca\\socialMedia\\';
		switch (type) {
			case SocialMediaType.Xing: return prefix + 'Xing_icon.svg';
			case SocialMediaType.Facebook: return prefix + 'facebook_icon_rgb.svg';
			case SocialMediaType.Twitter: return prefix + 'Twitter_Social_Icon_Circle_Color.svg';
			case SocialMediaType.Instagram: return prefix + 'instagram_icon.svg';
			case SocialMediaType.LinkedIn: return prefix + 'linkedin_icon.svg';
			case SocialMediaType.YouTube: return prefix + 'youtube_icon_rgb.svg';
			case SocialMediaType.Pinterest: return prefix + 'pinterest__icon.svg';
			default: return '';
		}
	}

	public getLink(link?: string) {
		if (link?.startsWith('http://') || link?.startsWith('https://')) {
			return link
		}
		return 'https://' + link;
	}

	openContactForm() {
		this.contactFormOpen.emit();
	}

}
